module.exports = __webpack_public_path__ + "static/img/gonganbeian.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gonganbeian.png
// module id = FOUl
// module chunks = 19